import React from 'react';

import { AdaptiveSingleLineText, Icons } from '@components/common';
import { getExt } from '@components/routes/AdminPanel/AssetHistory/AssetHistoryProfile/util';

import { IAssetFile } from '@interfaces/assets/asset';

import styles from './FilesListChanged.module.scss';

interface IFileProps {
	file: IAssetFile | null;
	maxWidth: number;
}

const File = ({ file, maxWidth }: IFileProps) => {
	const ext = getExt(file);

	return file &&
		<div className={styles.document}>
			<div className={styles.icon}>{Icons.fileIcon()}</div>
			<div className={styles.body}>
				<div className={styles.filename}>
					<div className={styles.name}>
						<AdaptiveSingleLineText
							className={styles.padding}
							maxWidth={maxWidth}
							paddingsSize={0}
							text={file.name}
						/>
					</div>
				</div>
				<div className={styles.description}>
					<div className={styles.extension}>{ext?.extension.toUpperCase()}</div>
					<div className={styles.size}>{ext?.convertedSize}</div>
				</div>
			</div>
		</div>;
};

export default File;
